<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Reported Ads" title="Reported Ads" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Reported Ads</span>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex">
										<label class="d-flex listing-length"><span>Show</span>
											<!-- <select class="form-control" v-model="listing_length" @change="fetchUsers()"> -->
											<select class="form-select">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-3">
										<!-- <div class="dropdown">
											<button class="dropbtn btn-primary" type="button">All Brands <span><i class="icofont icofont-arrow-down"></i></span></button>
											<div class="dropdown-content"><a href="#">Action</a><a href="#">Another Action</a><a href="#">Something Else Here</a></div>
										</div> -->
										<select class="form-select">
											<option value="2">Vehicles</option>
											<option value="3">Accessories & Spare parts</option>
										</select>
									</div>
									<div class="col-md-3">
										<input type="text" class="form-control" placeholder="Search"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th class="sorting_asc" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-sort="ascending" aria-label="Image: activate to sort column descending"
												style="width: 285.766px;">Image</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Title: activate to sort column ascending"
												style="width: 215.172px;">Title</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Reason: activate to sort column ascending"
												style="width: 285.25px;">Reason</th>
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Reported Date: activate to sort column ascending"
												style="width: 415.266px;">Reported Date</th>		
											<th class="sorting" tabindex="0" aria-controls="basic-1" rowspan="1" colspan="1"
												aria-label="Options: activate to sort column ascending"
												style="width: 285.266px;">Options</th>	
										</tr>
									</thead>
									<tbody v-if="Boolean(reports.length)">
										<tr v-for="report in reports" :key="report.id">
											<td><img :src="$image_url + report.image" alt="Image not found" style="width:100px" /></td>
											<td><p style="width: 200px">{{ report.title }}</p></td>
											<td>{{ report.reason }}</td>
											<td>{{$filters.formatDateTime(report.created_at) }}</td>
											<td>
												<a href="#" class="btn btn-sm btn-primary mt-2 me-1" @click.prevent="setBackURL(report.id)" >View Problem</a>

												<router-link v-if="type=='vehicle'" :to="{name: 'vehicles.show', params: { id: report.vehicle_id }}" class="btn btn-sm btn-primary mt-2 mr-1" >View Ad</router-link>
												<router-link v-if="type=='accessory'" :to="{name: 'accessories.show', params: { id: report.accessory_id }}" class="btn btn-sm btn-primary mt-2 mr-1" >View Ad</router-link>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="5" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: "ReportProblemsPage",
		data() {
			return {
				reports: [],
				types: [],			
				
				pagination: {},				
				
				keyword: "",
				showsearch: false,
				listing_length: 10,
				type: 'vehicle',
				token: "",
				errors: {},

				active_page_url: null,
				
			};
		},
		mounted() {
			
		},

		created() {
			this.fetchReports();
			this.fetchTypes();
		},

		methods: {
			fetchReports(page_url = null) {
				let url = "/api/admin/reported_problems?limit=" + this.listing_length + "&type=" + this.type + "&keyword=" + this.keyword;
				page_url = page_url || url;

				if(localStorage.back_url) {
		            page_url = localStorage.back_url;  
		            localStorage.removeItem('back_url');
		         }    

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						//console.log(responseData);
						this.reports = responseData.data;
						this.pagination = responseData.links;
					})
					.catch((err) => console.log(err));
			},

			fetchTypes() {
				this.getToken();
				this.$axios
					.get("/api/admin/category/types", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.types = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			getToken() {
         if (localStorage.getItem('slo_admin')) {
            var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
            if(slo_admin.token) {
               this.token = slo_admin.token;
               this.user = slo_admin;

            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "Login" });
            }

         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "Login" });
         }
      },

			setBackURL(report_id) {
		        localStorage.setItem('back_url', this.active_page_url);
		        this.$router.push({ name: 'ads.reported_problems.show', params: { id: report_id } });
		    },
			
		},
	};
</script>